import { Country } from '@cambridgeassessment/cambridge-ui';

const createCountry = (
  name: string,
  abbr: string,
  code: string,
  suggested?: boolean
): Country => {
  return { name, abbr, code, suggested };
};

export const Countries: Country[] = [
  createCountry('Afghanistan', 'AF', '+93'),
  createCountry('Alland Islands', 'AX', '+358'),
  createCountry('Albania', 'AL', '+355'),
  createCountry('Algeria', 'DZ', '+213'),
  createCountry('American Samoa', 'AS', '+1-684'),
  createCountry('Andorra', 'AD', '+376'),
  createCountry('Angola', 'AO', '+244'),
  createCountry('Anguilla', 'AI', '+1-264'),
  createCountry('Antarctica', 'AQ', '+672'),
  createCountry('Antigua and Barbuda', 'AG', '+1-268'),
  createCountry('Argentina', 'AR', '+54'),
  createCountry('Armenia', 'AM', '+374'),
  createCountry('Aruba', 'AW', '+297'),
  createCountry('Australia', 'AU', '+61', true),
  createCountry('Austria', 'AT', '+43'),
  createCountry('Azerbaijan', 'AZ', '+994'),
  createCountry('Bahamas', 'BS', '+1-242'),
  createCountry('Bahrain', 'BH', '+973'),
  createCountry('Bangladesh', 'BD', '+880'),
  createCountry('Barbados', 'BB', '+1-246'),
  createCountry('Belarus', 'BY', '+375'),
  createCountry('Belgium', 'BE', '+32'),
  createCountry('Belize', 'BZ', '+501'),
  createCountry('Benin', 'BJ', '+229'),
  createCountry('Bermuda', 'BM', '+1-441'),
  createCountry('Bhutan', 'BT', '+975'),
  createCountry('Bolivia', 'BO', '+591'),
  createCountry('Bonaire, Sint Eustatius and Saba', 'BQ', '+599'),
  createCountry('Bosnia and Herzegovina', 'BA', '+387'),
  createCountry('Botswana', 'BW', '+267'),
  createCountry('Bouvet Island', 'BV', '+47'),
  createCountry('Brazil', 'BR', '+55'),
  createCountry('British Indian Ocean Territory', 'IO', '+246'),
  createCountry('British Virgin Islands', 'VG', '+1-284'),
  createCountry('Brunei Darussalam', 'BN', '+673'),
  createCountry('Bulgaria', 'BG', '+359'),
  createCountry('Burkina Faso', 'BF', '+226'),
  createCountry('Burundi', 'BI', '+257'),
  createCountry('Cambodia', 'KH', '+855'),
  createCountry('Cameroon', 'CM', '+237'),
  createCountry('Canada', 'CA', '+1', true),
  createCountry('Cape Verde', 'CV', '+238'),
  createCountry('Cayman Islands', 'KY', '+1-345'),
  createCountry('Central African Republic', 'CF', '+236'),
  createCountry('Chad', 'TD', '+235'),
  createCountry('Chile', 'CL', '+56'),
  createCountry('China', 'CN', '+86'),
  createCountry('Christmas Island', 'CX', '+61'),
  createCountry('Cocos (Keeling) Islands', 'CC', '+61'),
  createCountry('Colombia', 'CO', '+57'),
  createCountry('Comoros', 'KM', '+269'),
  createCountry('Congo, Democratic Republic of the', 'CG', '+243'),
  createCountry('Congo, Republic of the', 'CD', '+242'),
  createCountry('Cook Islands', 'CK', '+682'),
  createCountry('Costa Rica', 'CR', '+506'),
  createCountry("Cote d'Ivoire", 'CI', '+225'),
  createCountry('Croatia', 'HR', '+385'),
  createCountry('Cuba', 'CU', '+53'),
  createCountry('Curacao', 'CW', '+599'),
  createCountry('Cyprus', 'CY', '+357'),
  createCountry('Czech Republic', 'CZ', '+420'),
  createCountry('Denmark', 'DK', '+45'),
  createCountry('Djibouti', 'DJ', '+253'),
  createCountry('Dominica', 'DM', '+1-767'),
  createCountry('Dominican Republic', 'DO', '+1-809'),
  createCountry('Ecuador', 'EC', '+593'),
  createCountry('Egypt', 'EG', '+20'),
  createCountry('El Salvador', 'SV', '+503'),
  createCountry('Equatorial Guinea', 'GQ', '+240'),
  createCountry('Eritrea', 'ER', '+291'),
  createCountry('Estonia', 'EE', '+372'),
  createCountry('Ethiopia', 'ET', '+251'),
  createCountry('Falkland Islands (Malvinas)', 'FK', '+500'),
  createCountry('Faroe Islands', 'FO', '+298'),
  createCountry('Fiji', 'FJ', '+679'),
  createCountry('Finland', 'FI', '+358'),
  createCountry('France', 'FR', '+33', true),
  createCountry('French Guiana', 'GF', '+594'),
  createCountry('French Polynesia', 'PF', '+689'),
  createCountry('French Southern Territories', 'TF', '+262'),
  createCountry('Gabon', 'GA', '+241'),
  createCountry('Gambia', 'GM', '+220'),
  createCountry('Georgia', 'GE', '+995'),
  createCountry('Germany', 'DE', '+49', true),
  createCountry('Ghana', 'GH', '+233'),
  createCountry('Gibraltar', 'GI', '+350'),
  createCountry('Greece', 'GR', '+30'),
  createCountry('Greenland', 'GL', '+299'),
  createCountry('Grenada', 'GD', '+1-473'),
  createCountry('Guadeloupe', 'GP', '+590'),
  createCountry('Guam', 'GU', '+1-671'),
  createCountry('Guatemala', 'GT', '+502'),
  createCountry('Guernsey', 'GG', '+44'),
  createCountry('Guinea-Bissau', 'GW', '+245'),
  createCountry('Guinea', 'GN', '+224'),
  createCountry('Guyana', 'GY', '+592'),
  createCountry('Haiti', 'HT', '+509'),
  createCountry('Heard Island and McDonald Islands', 'HM', '+672'),
  createCountry('Holy See (Vatican City State)', 'VA', '+379'),
  createCountry('Honduras', 'HN', '+504'),
  createCountry('Hong Kong', 'HK', '+852'),
  createCountry('Hungary', 'HU', '+36'),
  createCountry('Iceland', 'IS', '+354'),
  createCountry('India', 'IN', '+91'),
  createCountry('Indonesia', 'ID', '+62'),
  createCountry('Iran, Islamic Republic of', 'IR', '+98'),
  createCountry('Iraq', 'IQ', '+964'),
  createCountry('Ireland', 'IE', '+353'),
  createCountry('Isle of Man', 'IM', '+44'),
  createCountry('Israel', 'IL', '+972'),
  createCountry('Italy', 'IT', '+39'),
  createCountry('Jamaica', 'JM', '+1-876'),
  createCountry('Japan', 'JP', '+81', true),
  createCountry('Jersey', 'JE', '+44'),
  createCountry('Jordan', 'JO', '+962'),
  createCountry('Kazakhstan', 'KZ', '+7'),
  createCountry('Kenya', 'KE', '+254'),
  createCountry('Kiribati', 'KI', '+686'),
  createCountry("Korea, Democratic People's Republic of", 'KP', '+850'),
  createCountry('Korea, Republic of', 'KR', '+82'),
  createCountry('Kosovo', 'XK', '+383'),
  createCountry('Kuwait', 'KW', '+965'),
  createCountry('Kyrgyzstan', 'KG', '+996'),
  createCountry("Lao People's Democratic Republic", 'LA', '+856'),
  createCountry('Latvia', 'LV', '+371'),
  createCountry('Lebanon', 'LB', '+961'),
  createCountry('Lesotho', 'LS', '+266'),
  createCountry('Liberia', 'LR', '+231'),
  createCountry('Libya', 'LY', '+218'),
  createCountry('Liechtenstein', 'LI', '+423'),
  createCountry('Lithuania', 'LT', '+370'),
  createCountry('Luxembourg', 'LU', '+352'),
  createCountry('Macao', 'MO', '+853'),
  createCountry('Macedonia, the Former Yugoslav Republic of', 'MK', '+389'),
  createCountry('Madagascar', 'MG', '+261'),
  createCountry('Malawi', 'MW', '+265'),
  createCountry('Malaysia', 'MY', '+60'),
  createCountry('Maldives', 'MV', '+960'),
  createCountry('Mali', 'ML', '+223'),
  createCountry('Malta', 'MT', '+356'),
  createCountry('Marshall Islands', 'MH', '+692'),
  createCountry('Martinique', 'MQ', '+596'),
  createCountry('Mauritania', 'MR', '+222'),
  createCountry('Mauritius', 'MU', '+230'),
  createCountry('Mayotte', 'YT', '+262'),
  createCountry('Mexico', 'MX', '+52'),
  createCountry('Micronesia, Federated States of', 'FM', '+691'),
  createCountry('Moldova, Republic of', 'MD', '+373'),
  createCountry('Monaco', 'MC', '+377'),
  createCountry('Mongolia', 'MN', '+976'),
  createCountry('Montenegro', 'ME', '+382'),
  createCountry('Montserrat', 'MS', '+1-664'),
  createCountry('Morocco', 'MA', '+212'),
  createCountry('Mozambique', 'MZ', '+258'),
  createCountry('Myanmar', 'MM', '+95'),
  createCountry('Namibia', 'NA', '+264'),
  createCountry('Nauru', 'NR', '+674'),
  createCountry('Nepal', 'NP', '+977'),
  createCountry('Netherlands', 'NL', '+31'),
  createCountry('New Caledonia', 'NC', '+687'),
  createCountry('New Zealand', 'NZ', '+64'),
  createCountry('Nicaragua', 'NI', '+505'),
  createCountry('Niger', 'NE', '+227'),
  createCountry('Nigeria', 'NG', '+234'),
  createCountry('Niue', 'NU', '+683'),
  createCountry('Norfolk Island', 'NF', '+672'),
  createCountry('Northern Mariana Islands', 'MP', '+1-670'),
  createCountry('Norway', 'NO', '+47'),
  createCountry('Oman', 'OM', '+968'),
  createCountry('Pakistan', 'PK', '+92'),
  createCountry('Palau', 'PW', '+680'),
  createCountry('Palestine, State of', 'PS', '+970'),
  createCountry('Panama', 'PA', '+507'),
  createCountry('Papua New Guinea', 'PG', '+675'),
  createCountry('Paraguay', 'PY', '+595'),
  createCountry('Peru', 'PE', '+51'),
  createCountry('Philippines', 'PH', '+63'),
  createCountry('Pitcairn', 'PN', '+870'),
  createCountry('Poland', 'PL', '+48'),
  createCountry('Portugal', 'PT', '+351'),
  createCountry('Puerto Rico', 'PR', '+1'),
  createCountry('Qatar', 'QA', '+974'),
  createCountry('Reunion', 'RE', '+262'),
  createCountry('Romania', 'RO', '+40'),
  createCountry('Russian Federation', 'RU', '+7'),
  createCountry('Rwanda', 'RW', '+250'),
  createCountry('Saint Barthelemy', 'BL', '+590'),
  createCountry('Saint Helena', 'SH', '+290'),
  createCountry('Saint Kitts and Nevis', 'KN', '+1-869'),
  createCountry('Saint Lucia', 'LC', '+1-758'),
  createCountry('Saint Martin (French part)', 'MF', '+590'),
  createCountry('Saint Pierre and Miquelon', 'PM', '+508'),
  createCountry('Saint Vincent and the Grenadines', 'VC', '+1-784'),
  createCountry('Samoa', 'WS', '+685'),
  createCountry('San Marino', 'SM', '+378'),
  createCountry('Sao Tome and Principe', 'ST', '+239'),
  createCountry('Saudi Arabia', 'SA', '+966'),
  createCountry('Senegal', 'SN', '+221'),
  createCountry('Serbia', 'RS', '+381'),
  createCountry('Seychelles', 'SC', '+248'),
  createCountry('Sierra Leone', 'SL', '+232'),
  createCountry('Singapore', 'SG', '+65'),
  createCountry('Sint Maarten (Dutch part)', 'SX', '+1-721'),
  createCountry('Slovakia', 'SK', '+421'),
  createCountry('Slovenia', 'SI', '+386'),
  createCountry('Solomon Islands', 'SB', '+677'),
  createCountry('Somalia', 'SO', '+252'),
  createCountry('South Africa', 'ZA', '+27'),
  createCountry('South Georgia and the South Sandwich Islands', 'GS', '+500'),
  createCountry('South Sudan', 'SS', '+211'),
  createCountry('Spain', 'ES', '+34'),
  createCountry('Sri Lanka', 'LK', '+94'),
  createCountry('Sudan', 'SD', '+249'),
  createCountry('Suriname', 'SR', '+597'),
  createCountry('Svalbard and Jan Mayen', 'SJ', '+47'),
  createCountry('Swaziland', 'SZ', '+268'),
  createCountry('Sweden', 'SE', '+46'),
  createCountry('Switzerland', 'CH', '+41'),
  createCountry('Syrian Arab Republic', 'SY', '+963'),
  createCountry('Taiwan, Province of China', 'TW', '+886'),
  createCountry('Tajikistan', 'TJ', '+992'),
  createCountry('Thailand', 'TH', '+66'),
  createCountry('Timor-Leste', 'TL', '+670'),
  createCountry('Togo', 'TG', '+228'),
  createCountry('Tokelau', 'TK', '+690'),
  createCountry('Tonga', 'TO', '+676'),
  createCountry('Trinidad and Tobago', 'TT', '+1-868'),
  createCountry('Tunisia', 'TN', '+216'),
  createCountry('Türkiye', 'TR', '+90'),
  createCountry('Turkmenistan', 'TM', '+993'),
  createCountry('Turks and Caicos Islands', 'TC', '+1-649'),
  createCountry('Tuvalu', 'TV', '+688'),
  createCountry('Uganda', 'UG', '+256'),
  createCountry('Ukraine', 'UA', '+380'),
  createCountry('United Arab Emirates', 'AE', '+971'),
  createCountry('United Kingdom', 'GB', '+44', true),
  createCountry('United Republic of Tanzania', 'TZ', '+255'),
  createCountry('United States', 'US', '+1', true),
  createCountry('United States Minor Outlying Islands', 'UM', '+1'),
  createCountry('Uruguay', 'UY', '+598'),
  createCountry('US Virgin Islands', 'VI', '+1-340'),
  createCountry('Uzbekistan', 'UZ', '+998'),
  createCountry('Vanuatu', 'VU', '+678'),
  createCountry('Venezuela', 'VE', '+58'),
  createCountry('Vietnam', 'VN', '+84'),
  createCountry('Wallis and Futuna', 'WF', '+681'),
  createCountry('Western Sahara', 'EH', '+212'),
  createCountry('Yemen', 'YE', '+967'),
  createCountry('Zambia', 'ZM', '+260'),
  createCountry('Zimbabwe', 'ZW', '+263'),
];
